import { z } from 'zod/v4';
import {
  SOLAR_SAVINGS_RATES,
  type SolarSavingsRegion,
} from './solarSavingsConstants';

export const solarTariffSchemas = {
  retail: z.number().gt(0).lte(100),
  export: z.number().gte(0).lte(100),
};

export type SolarTariffKind = keyof typeof solarTariffSchemas;

export const solarTariffErrorMessage = (
  kind: SolarTariffKind,
  region: SolarSavingsRegion
): string => {
  const range =
    kind === 'retail'
      ? 'a retail rate above 0 and up to 100'
      : 'an export rate from 0 to 100';
  const unit = region === 'us' ? '¢/kWh' : 'p/kWh';
  const example = SOLAR_SAVINGS_RATES[region][`${kind}TariffMinorPerKwh`];
  return `Enter ${range} ${unit} (e.g. ${example})`;
};
